<template>
  <div class="header py-4">
    <div class="container">
      <div class="d-flex">
        <router-link :to="{name:'Horaires'}"  class="header-brand"> 
          <img src="~src/assets/images/logo.png" class="header-brand-img" alt="tabler logo">
        </router-link>

        <div class="d-flex order-lg-2 ml-auto header-username">
          <!-- <div class="nav-item d-none d-md-flex">
            <a :href="lienIntranet()" class="btn btn-sm btn-outline-primary" target="_blank">Intranet</a>
          </div> -->

          <div class="dropdown">
            <a href="#" class="nav-link pr-0 leading-none" data-toggle="dropdown">
              <span class="avatar"><i class="fe fe-user"></i></span>
              <span class="ml-2 d-none d-lg-block">
                <span class="text-default">{{ $auth.user().username }}</span>
                <small class="text-muted d-block mt-1">Administrateur</small>
              </span>
            </a>
            <div class="dropdown-menu dropdown-menu-right dropdown-menu-arrow">
              <router-link :to="{name:'MotPasse'}" class="dropdown-item"> 
                <i class="dropdown-icon fe fe-user"></i> Modifier le mot de passe
              </router-link>

              <a class="dropdown-item" href="#" v-on:click="$auth.logout({redirect: '/login',})">
                <i class="dropdown-icon fe fe-log-out"></i> Se déconnecter
              </a>
            </div>
          </div>
        </div>
        <a href="#" class="header-toggler d-lg-none ml-3 ml-lg-0" 
            data-toggle="collapse" data-target="#headerMenuCollapse">
          <span class="header-toggler-icon"></span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex'

  export default {
    data() {
      return {
      }
    },
    computed: {
      ...mapState([
      ]),
    },
    methods: {
      ...mapMutations([
      ]),
    },
  };
</script>


// WEBPACK FOOTER //
// Header.vue?631f97e4